import React, { Component } from 'react';
import Grid from "@mui/material/Grid";
import Switch from '../../../components/Switch.js';
import Bubble from '../../../components/Bubble.js';
import BubbleSelectBlock from '../../../components/BubbleSelectBlock.js';
import NumberInput from '../../../components/TextFields/NumberInput.js';
import Text from '../../../components/Text.js';
import TextInput from '../../../components/TextFields/TextInput.js';
import BlockContent from '../../../components/BlockContent.js';
import HeaderDiv from '../../../components/HeaderDiv.js';
import { colors } from '../../../theme/index.js';
import i18n from '../../../localization/i18n.js';
import tokens from '../../../localization/tokens.js';
import { selectFieldOptions } from '../../../services/index.js';
import * as localizationMaps from '../../../localization/maps.js';
class Drugs extends Component {
  state = {
    data: null
  };
  componentDidMount() {
    const defaults = this._setData(this.props.data);

    // we are viewing a revision so we don't need to set data in state
    if (this.props.revision) {
      return;
    }
    if (this.props.type === "modular") {
      // save the init data in global state so it's there for the save
      this.props.saveModularBenefitInitData(this.props.classID, this.props.tier, 'health', 'drugs', defaults);
      return;
    }

    // save the init data in global state so it's there for the save
    this.props.savePlanDesignBenefitInitData(this.props.selectedClassID, this.props.selectedDesignID, 'drugs', defaults);
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    const defaults = this._setData(nextProps.data);

    // we are viewing a revision so we don't need to set data in state
    if (this.props.revision) {
      return;
    }
    if (this.props.type === "modular") {
      return;
    }
    if (nextProps.selectedDesignID !== this.props.selectedDesignID) {
      // save the init data in global state so it's there for the save
      this.props.savePlanDesignBenefitInitData(this.props.selectedClassID, nextProps.selectedDesignID, 'drugs', defaults);
    }
  }
  _setData = data => {
    const defaults = {
      isSelected: data.isSelected || false,
      hasDeductible: data.hasDeductible || false,
      deductibleAmountSelected: data.deductibleAmountSelected === undefined ? true : data.deductibleAmountSelected,
      deductibleEqualToDispenseFee: data.deductibleEqualToDispenseFee || false,
      soloDeductibleAmount: data.soloDeductibleAmount || 0,
      duoDeductibleAmount: data.duoDeductibleAmount || 0,
      familyDeductibleAmount: data.familyDeductibleAmount || 0,
      reimbursement: typeof data.reimbursement === "number" ? data.reimbursement : 80,
      genericSubstitute: data.genericSubstitute || 'Mandatory Generic',
      isPreferredProvider: data.isPreferredProvider || false,
      preferredProviderReimbursement: data.preferredProviderReimbursement || 0,
      preferredProvider: data.preferredProvider || 'Other',
      hasOverallMax: data.hasOverallMax || false,
      overallMax: data.overallMax || 0,
      isGraded: data.isGraded || false,
      firstPercentage: typeof data.firstPercentage === "number" ? data.firstPercentage : 80,
      firstMax: data.firstMax || 0,
      secondMaxType: data.secondMaxType || 'Unlimited',
      secondPercentage: typeof data.secondPercentage === "number" ? data.secondPercentage : 100,
      secondMax: data.secondMax || 0,
      hasDispenseFeeMax: data.hasDispenseFeeMax || false,
      dispenseFeeMax: data.dispenseFeeMax || 0,
      includeErectDysfuncDrugs: data.includeErectDysfuncDrugs || false,
      edReimbursement: data.edReimbursement || 0,
      edMax: data.edMax || 0,
      includeFertilityDrugs: data.includeFertilityDrugs || false,
      fertilityReimbursement: typeof data.fertilityReimbursement === "number" ? data.fertilityReimbursement : 0,
      fertilityMax: typeof data.fertilityMax === "number" ? data.fertilityMax : 0,
      includePreventativeVaccines: data.includePreventativeVaccines || false,
      preventativeVaccinesIsRC: data.preventativeVaccinesIsRC === undefined ? false : data.preventativeVaccinesIsRC,
      preventativeVaccinesMax: typeof data.preventativeVaccinesMax === "number" ? data.preventativeVaccinesMax : 0,
      preventativeVaccinesReimbursement: typeof data.preventativeVaccinesReimbursement === "number" ? data.preventativeVaccinesReimbursement : 0,
      includeSmokingCessations: data.includeSmokingCessations || false,
      smokingCessationsMax: typeof data.smokingCessationsMax === "number" ? data.smokingCessationsMax : 0,
      smokingCessationsReimbursement: typeof data.smokingCessationsReimbursement === "number" ? data.smokingCessationsReimbursement : 0,
      terminationAge: typeof data.terminationAge === "number" ? data.terminationAge : 75,
      eligibilityPeriod: typeof data.eligibilityPeriod === "number" ? data.eligibilityPeriod : 3,
      minHoursPerWeek: typeof data.minHoursPerWeek === "number" ? data.minHoursPerWeek : 24,
      notes: data.notes || null,
      stopLoss: data.stopLoss || 0
    };

    // if the second max is unlimited then set the second max to unlimited
    if (defaults.secondMaxType.toUpperCase() === 'UNLIMITED') {
      defaults.secondMax = 'Unlimited';
    }
    this.setState({
      data: {
        ...defaults
      }
    });
    return defaults;
  };
  _handleChange = (field, value) => {
    // we are viewing a revision so we don't need to set data in state
    if (this.props.revision) {
      return;
    }
    const data = {
      ...this.state.data,
      [field]: value
    };
    this.setState({
      data
    });
  };
  _saveInGlobalState = (field, value) => {
    // we are viewing a revision so we don't need to set data in state
    if (this.props.revision) {
      return;
    }
    if (field === 'notes' && value.toString().length === 0) {
      value = null;
    }
    if (this.props.type === "modular") {
      this.props.saveModularField(this.props.classID, this.props.tier, 'health', 'drugs', field, value);
    } else {
      this.props.savePlanDesignField(this.props.selectedClassID, this.props.selectedDesignID, 'drugs', field, value);
    }

    // if the second max is unlimited then set the second max to unlimited
    if (value && field === 'secondMaxType' && value.toUpperCase() === 'UNLIMITED') {
      this._saveInGlobalState("secondMax", 'Unlimited');
    }
    this.props.setChangesMadeFlag();
  };
  render() {
    if (!this.state.data) {
      return null;
    }
    const {
      errors,
      whitelabel,
      revision,
      isRevisionBlock,
      lightTierColor,
      darkTierColor
    } = this.props;
    const data = this.state.data;
    const isSelected = Boolean(data.isSelected);
    const tierLabelStyle = {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 90,
      padding: 5,
      marginRight: 10,
      backgroundColor: lightTierColor
    };
    return /*#__PURE__*/React.createElement(BlockContent, {
      style: isRevisionBlock ? {
        backgroundColor: '#F7F9FA'
      } : null
    }, /*#__PURE__*/React.createElement(HeaderDiv, {
      style: {
        borderBottom: isSelected ? "1.5px solid #F1F1F1" : null
      }
    }, /*#__PURE__*/React.createElement(Text, {
      bold: true,
      large: true,
      display: "block",
      margin: "20px 0",
      color: whitelabel.primaryColor || colors.skyBlue
    }, revision ? isRevisionBlock ? `${i18n.t(tokens.titles.drugs)} (${revision.revisionID})` : i18n.t(tokens.labels.planDesign.drugsCurrent) : i18n.t(tokens.titles.drugs)), /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'flex',
        justifyContent: 'flex-end',
        flexDirection: 'row',
        flex: 1
      }
    }, this.props.tier && /*#__PURE__*/React.createElement("div", {
      style: tierLabelStyle
    }, /*#__PURE__*/React.createElement(Text, {
      bold: true,
      medium: true,
      color: darkTierColor
    }, this.props.tier.toUpperCase())), /*#__PURE__*/React.createElement(Switch, {
      checked: data.isSelected,
      onChange: () => this._saveInGlobalState("isSelected", !isSelected)
    }))), isSelected && /*#__PURE__*/React.createElement("div", {
      style: {
        paddingTop: 20,
        paddingBottom: 50
      }
    }, /*#__PURE__*/React.createElement(Text, {
      small: true
    }, i18n.t(tokens.labels.planDesign.selectBetween)), /*#__PURE__*/React.createElement(BubbleSelectBlock, {
      first: {
        title: i18n.t(tokens.labels.planDesign.deductible),
        selected: data.hasDeductible === true,
        field: 'hasDeductible'
      },
      second: {
        title: i18n.t(tokens.labels.planDesign.nonDeductible),
        selected: data.hasDeductible === false,
        field: 'hasDeductible'
      },
      handleChange: () => this._saveInGlobalState('hasDeductible', !data.hasDeductible)
    }), data.hasDeductible && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BubbleSelectBlock, {
      first: {
        title: i18n.t(tokens.labels.planDesign.amount),
        selected: data.deductibleAmountSelected,
        field: 'deductibleAmountSelected'
      },
      second: {
        title: i18n.t(tokens.labels.planDesign.equalToDispenseFee),
        selected: data.deductibleEqualToDispenseFee,
        field: 'deductibleEqualToDispenseFee'
      },
      handleChange: this._saveInGlobalState
    }), data.deductibleAmountSelected && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
      small: true
    }, i18n.t(tokens.labels.planDesign.completeFollowing)), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center",
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.advisor.solo),
      prefix: "$ ",
      fullWidth: true,
      value: data.soloDeductibleAmount,
      variant: "outlined",
      onChange: e => this._handleChange("soloDeductibleAmount", e.target.value),
      onBlur: e => this._saveInGlobalState("soloDeductibleAmount", e.target.value),
      error: errors.soloDeductibleAmount
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.advisor.duo),
      prefix: "$ ",
      fullWidth: true,
      value: data.duoDeductibleAmount,
      variant: "outlined",
      onChange: e => this._handleChange("duoDeductibleAmount", e.target.value),
      onBlur: e => this._saveInGlobalState("duoDeductibleAmount", e.target.value),
      error: errors.duoDeductibleAmount
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.advisor.family),
      prefix: "$ ",
      fullWidth: true,
      value: data.familyDeductibleAmount,
      variant: "outlined",
      onChange: e => this._handleChange("familyDeductibleAmount", e.target.value),
      onBlur: e => this._saveInGlobalState("familyDeductibleAmount", e.target.value),
      error: errors.familyDeductibleAmount
    }))))), /*#__PURE__*/React.createElement(Text, {
      small: true
    }, i18n.t(tokens.labels.planDesign.completeFollowing)), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center",
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(Bubble, {
      label: i18n.t(tokens.labels.planDesign.gradedDrugScale),
      isSelected: data.isGraded,
      onClick: () => this._saveInGlobalState("isGraded", !data.isGraded)
    }))), data.isGraded && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center",
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.planDesign.percentageOfFirstMaximum),
      fullWidth: true,
      value: data.firstPercentage,
      variant: "outlined",
      suffix: "%",
      onChange: e => this._handleChange("firstPercentage", e.target.value),
      onBlur: e => this._saveInGlobalState("firstPercentage", e.target.value),
      error: errors.firstPercentage
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.planDesign.percentageOfSecondMaximum),
      fullWidth: true,
      value: data.secondPercentage,
      variant: "outlined",
      suffix: "%",
      onChange: e => this._handleChange("secondPercentage", e.target.value),
      onBlur: e => this._saveInGlobalState("secondPercentage", e.target.value),
      error: errors.secondPercentage
    }))), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center",
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.planDesign.firstMaximum),
      fullWidth: true,
      value: data.firstMax,
      variant: "outlined",
      prefix: "$ ",
      onChange: e => this._handleChange("firstMax", e.target.value),
      onBlur: e => this._saveInGlobalState("firstMax", e.target.value),
      error: errors.firstMax
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(TextInput, {
      label: i18n.t(tokens.labels.planDesign.secondMaximumType),
      fullWidth: true,
      value: localizationMaps.fromEnglish('drugsMaximumType', data.secondMaxType),
      variant: "outlined",
      onChange: e => this._handleChange("secondMaxType", localizationMaps.toEnglish('drugsMaximumType', e.target.value)),
      onBlur: e => this._saveInGlobalState("secondMaxType", localizationMaps.toEnglish('drugsMaximumType', e.target.value)),
      error: errors.secondMaxType,
      select: true,
      selectOptions: selectFieldOptions.drugsMaximumTypes()
    })), data.secondMaxType === 'Dollar Amount' && /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.planDesign.secondMaximum),
      fullWidth: true,
      value: data.secondMax,
      variant: "outlined",
      prefix: "$ ",
      onChange: e => this._handleChange("secondMax", e.target.value),
      onBlur: e => this._saveInGlobalState("secondMax", e.target.value),
      error: errors.secondMax
    })))), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center",
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.titles.stopLoss),
      prefix: "$ ",
      fullWidth: true,
      value: data.stopLoss,
      variant: "outlined",
      onChange: e => this._handleChange("stopLoss", e.target.value),
      onBlur: e => this._saveInGlobalState("stopLoss", e.target.value),
      error: errors.stopLoss
    })), !data.isGraded && /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.planDesign.reimbursement),
      fullWidth: true,
      suffix: "%",
      value: data.reimbursement,
      variant: "outlined",
      onChange: e => this._handleChange("reimbursement", e.target.value),
      onBlur: e => this._saveInGlobalState("reimbursement", e.target.value),
      error: errors.reimbursement
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 4
    }, /*#__PURE__*/React.createElement(TextInput, {
      label: i18n.t(tokens.labels.planDesign.drugPlanType),
      fullWidth: true,
      value: localizationMaps.fromEnglish('genericSubstitute', data.genericSubstitute),
      variant: "outlined",
      onChange: e => this._handleChange("genericSubstitute", localizationMaps.toEnglish('genericSubstitute', e.target.value)),
      onBlur: e => this._saveInGlobalState("genericSubstitute", localizationMaps.toEnglish('genericSubstitute', e.target.value)),
      error: errors.genericSubstitute,
      select: true,
      selectOptions: selectFieldOptions.genericSubstituteTypes()
    }))), /*#__PURE__*/React.createElement(Text, {
      small: true
    }, i18n.t(tokens.labels.planDesign.selectItemsIncluded)), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center",
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(Bubble, {
      label: i18n.t(tokens.labels.planDesign.preferredProviderNetwork),
      isSelected: data.isPreferredProvider,
      onClick: () => this._saveInGlobalState("isPreferredProvider", !data.isPreferredProvider)
    }))), data.isPreferredProvider && /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center",
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.planDesign.reimbursement),
      fullWidth: true,
      value: data.preferredProviderReimbursement,
      variant: "outlined",
      suffix: "%",
      onChange: e => this._handleChange("preferredProviderReimbursement", e.target.value),
      onBlur: e => this._saveInGlobalState("preferredProviderReimbursement", e.target.value),
      error: errors.preferredProviderReimbursement
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(TextInput, {
      label: i18n.t(tokens.labels.planDesign.provider),
      fullWidth: true,
      value: localizationMaps.fromEnglish('preferredProvider', data.preferredProvider),
      variant: "outlined",
      error: errors.preferredProvider,
      onChange: e => this._handleChange("preferredProvider", localizationMaps.toEnglish('preferredProvider', e.target.value)),
      onBlur: e => this._saveInGlobalState("preferredProvider", localizationMaps.toEnglish('preferredProvider', e.target.value)),
      select: true,
      selectOptions: selectFieldOptions.preferredProviderOptions()
    }))), !data.isGraded && /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center",
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(Bubble, {
      label: i18n.t(tokens.labels.planDesign.overallMaximumCalendarYear),
      isSelected: data.hasOverallMax,
      onClick: () => this._saveInGlobalState("hasOverallMax", !data.hasOverallMax)
    }))), data.hasOverallMax && /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center",
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.planDesign.overallMaximum),
      value: data.overallMax,
      variant: "outlined",
      prefix: "$ ",
      fullWidth: true,
      onChange: e => this._handleChange("overallMax", e.target.value),
      onBlur: e => this._saveInGlobalState("overallMax", e.target.value),
      error: errors.overallMax
    }))), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center",
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(Bubble, {
      label: i18n.t(tokens.labels.planDesign.dispenseFeeMaximum),
      isSelected: data.hasDispenseFeeMax,
      onClick: () => this._saveInGlobalState("hasDispenseFeeMax", !data.hasDispenseFeeMax)
    }))), data.hasDispenseFeeMax && /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center",
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.planDesign.dispenseFeeMaximum),
      value: data.dispenseFeeMax,
      variant: "outlined",
      prefix: "$ ",
      fullWidth: true,
      onChange: e => this._handleChange("dispenseFeeMax", e.target.value),
      onBlur: e => this._saveInGlobalState("dispenseFeeMax", e.target.value),
      error: errors.dispenseFeeMax
    }))), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center",
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(Bubble, {
      label: i18n.t(tokens.labels.planDesign.erectileDysfunctionDrugs),
      isSelected: data.includeErectDysfuncDrugs,
      onClick: () => this._saveInGlobalState("includeErectDysfuncDrugs", !data.includeErectDysfuncDrugs)
    }))), data.includeErectDysfuncDrugs && /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center",
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.planDesign.edReimbursement),
      value: data.edReimbursement,
      fullWidth: true,
      variant: "outlined",
      suffix: "%",
      onChange: e => this._handleChange("edReimbursement", e.target.value),
      onBlur: e => this._saveInGlobalState("edReimbursement", e.target.value),
      error: errors.edReimbursement
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.planDesign.edMaximum),
      value: data.edMax,
      fullWidth: true,
      variant: "outlined",
      prefix: "$ ",
      onChange: e => this._handleChange("edMax", e.target.value),
      onBlur: e => this._saveInGlobalState("edMax", e.target.value),
      error: errors.edMax
    }))), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center",
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(Bubble, {
      label: i18n.t(tokens.labels.planDesign.fertilityDrugs),
      isSelected: data.includeFertilityDrugs,
      onClick: () => this._saveInGlobalState("includeFertilityDrugs", !data.includeFertilityDrugs)
    }))), data.includeFertilityDrugs && /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center",
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.planDesign.fertilityReimbursement),
      value: data.fertilityReimbursement,
      fullWidth: true,
      variant: "outlined",
      suffix: "%",
      onChange: e => this._handleChange("fertilityReimbursement", e.target.value),
      onBlur: e => this._saveInGlobalState("fertilityReimbursement", e.target.value),
      error: errors.fertilityReimbursement
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.planDesign.fertilityMaximumLifetime),
      value: data.fertilityMax,
      fullWidth: true,
      variant: "outlined",
      prefix: "$ ",
      onChange: e => this._handleChange("fertilityMax", e.target.value),
      onBlur: e => this._saveInGlobalState("fertilityMax", e.target.value),
      error: errors.fertilityMax
    }))), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center",
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(Bubble, {
      label: i18n.t(tokens.labels.planDesign.preventativeVaccines),
      isSelected: data.includePreventativeVaccines,
      onClick: () => this._saveInGlobalState("includePreventativeVaccines", !data.includePreventativeVaccines)
    }))), data.includePreventativeVaccines && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
      small: true
    }, i18n.t(tokens.labels.planDesign.selectMaximumTypes)), /*#__PURE__*/React.createElement(BubbleSelectBlock, {
      first: {
        title: i18n.t(tokens.labels.planDesign.dollarAmount),
        selected: data.preventativeVaccinesIsRC === false,
        field: 'preventativeVaccinesIsRC'
      },
      second: {
        title: i18n.t(tokens.labels.coverage.reasonableAndCustomary),
        selected: data.preventativeVaccinesIsRC === true,
        field: 'preventativeVaccinesIsRC'
      },
      handleChange: () => this._saveInGlobalState('preventativeVaccinesIsRC', !data.preventativeVaccinesIsRC)
    }), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center",
      spacing: 2
    }, !data.preventativeVaccinesIsRC && /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.planDesign.preventativeVaccinesMaximum),
      value: data.preventativeVaccinesMax,
      fullWidth: true,
      variant: "outlined",
      prefix: "$ ",
      onChange: e => this._handleChange("preventativeVaccinesMax", e.target.value),
      onBlur: e => this._saveInGlobalState("preventativeVaccinesMax", e.target.value),
      error: errors.preventativeVaccinesMax
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.planDesign.preventativeVaccinesReimbursement),
      value: data.preventativeVaccinesReimbursement,
      fullWidth: true,
      variant: "outlined",
      suffix: "%",
      onChange: e => this._handleChange("preventativeVaccinesReimbursement", e.target.value),
      onBlur: e => this._saveInGlobalState("preventativeVaccinesReimbursement", e.target.value),
      error: errors.preventativeVaccinesReimbursement
    })))), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center",
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(Bubble, {
      label: i18n.t(tokens.labels.planDesign.smokingCessations),
      isSelected: data.includeSmokingCessations,
      onClick: () => this._saveInGlobalState("includeSmokingCessations", !data.includeSmokingCessations)
    }))), data.includeSmokingCessations && /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center",
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.planDesign.smokingCessationsReimbursement),
      value: data.smokingCessationsReimbursement,
      fullWidth: true,
      variant: "outlined",
      suffix: "%",
      onChange: e => this._handleChange("smokingCessationsReimbursement", e.target.value),
      onBlur: e => this._saveInGlobalState("smokingCessationsReimbursement", e.target.value),
      error: errors.smokingCessationsReimbursement
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.planDesign.smokingCessationsMaximumLifetime),
      value: data.smokingCessationsMax,
      fullWidth: true,
      variant: "outlined",
      prefix: "$ ",
      onChange: e => this._handleChange("smokingCessationsMax", e.target.value),
      onBlur: e => this._saveInGlobalState("smokingCessationsMax", e.target.value),
      error: errors.smokingCessationsMax
    }))), /*#__PURE__*/React.createElement(Text, {
      mediumLarge: true,
      bold: true,
      margin: "20px 0 10px 0"
    }, i18n.t(tokens.labels.planDesign.planEligibilityTermination)), /*#__PURE__*/React.createElement(Text, {
      small: true
    }, i18n.t(tokens.labels.planDesign.completeFollowing)), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center",
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.planDesign.eligibilityPeriodMonths),
      value: data.eligibilityPeriod,
      variant: "outlined",
      fullWidth: true,
      onChange: e => this._handleChange("eligibilityPeriod", e.target.value),
      onBlur: e => this._saveInGlobalState("eligibilityPeriod", e.target.value),
      error: errors.eligibilityPeriod
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.planDesign.minimumHoursPerWeek),
      value: data.minHoursPerWeek,
      variant: "outlined",
      fullWidth: true,
      onChange: e => this._handleChange("minHoursPerWeek", e.target.value),
      onBlur: e => this._saveInGlobalState("minHoursPerWeek", e.target.value),
      error: errors.minHoursPerWeek
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.planDesign.terminationAge),
      fullWidth: true,
      value: data.terminationAge,
      variant: "outlined",
      onChange: e => this._handleChange("terminationAge", e.target.value),
      onBlur: e => this._saveInGlobalState("terminationAge", e.target.value),
      error: errors.terminationAge
    }))), /*#__PURE__*/React.createElement(Text, {
      small: true,
      margin: "20px 0 0 0",
      bold: true
    }, "Notes:"), /*#__PURE__*/React.createElement(TextInput, {
      fullWidth: true,
      value: data.notes || '',
      variant: "outlined",
      error: errors.notes,
      onChange: e => this._handleChange("notes", e.target.value),
      onBlur: e => this._saveInGlobalState("notes", e.target.value),
      multiline: true,
      rows: 5,
      placeholder: i18n.t(tokens.labels.planDesign.additionalRequestsInformation)
    })));
  }
}
export default Drugs;